module.exports = __webpack_public_path__ + "static/img/AE.34c24f48.svg";